import { defineField, defineType } from 'sanity'
import { strongEmLink } from '../../data/richText'

export default defineType({
  title: 'Myth',
  name: 'myth',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      description: 'Title',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: strongEmLink,
      validation: (Rule) => Rule.required(),
    }),
    defineField({
      title: 'Button',
      type: 'link',
      name: 'button',
    }),
  ],
})